import script from "./WeekDay.vue?vue&type=script&setup=true&lang=js"
export * from "./WeekDay.vue?vue&type=script&setup=true&lang=js"

import "./WeekDay.vue?vue&type=style&index=0&id=4f3504e5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f3504e5"]])

export default __exports__